import { render } from "./PapagoHeader.vue?vue&type=template&id=7025800c"
import script from "./PapagoHeader.vue?vue&type=script&lang=js"
export * from "./PapagoHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__